<script setup lang="ts">
import TemplatesList from "@/components/report-templates/TemplatesList.vue";
</script>

<template>
  <TemplatesList />
</template>
